<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="magazine-editors-management"
            :fields="editorsTableFields"
            :items="users">
            <template #options>
                <b-button
                    class="btn-add-existing-user"
                    v-if="isChiefEditor"
                    v-b-modal="'add-existing-magazine-editor-user'"
                    variant="primary">
                    <i class="btn-user-add"></i>{{ $t('magazine.select_user') }}
                </b-button>

                <b-button
                    class="btn-add btn-add-existing-user"
                    v-if="isChiefEditor"
                    v-b-modal="'create-new-magazine-editor-user'"
                    variant="primary">
                    {{ $t('magazine.add_user') }}
                </b-button>
                <design-2021-magazine-editor-add-existing-user-component
                    :magazine-id="magazineId"
                    @update-users="updateUsers">
                </design-2021-magazine-editor-add-existing-user-component>

                <design-2021-magazine-editor-create-new-user-component
                    :magazine-id="magazineId"
                    @update-users="updateUsers">
                </design-2021-magazine-editor-create-new-user-component>
            </template>

            <template #cell(surname)="data">
                <span class="name">
                    {{ data.value }}
                </span>
            </template>

            <template #cell(role)="row">
                <b-form-select
                    class="editors-role-type-select apprentice-primary-select"
                    v-if="isChiefEditor"
                    v-model="row.item.pivot.role"
                    :options="roleoptions"
                    @change="updateRole($event, row.item.id)">
                </b-form-select>
                <span v-if="!isChiefEditor && row.item.pivot.role == 2">{{ $t('magazine.editor') }}</span>
                <span v-if="!isChiefEditor && row.item.pivot.role == 1">{{ $t('magazine.chief_editor') }}</span>
            </template>

            <template #cell(userrole)="row">
                {{ row.item.type_name }}
            </template>

            <template #cell(actions)="row">
                <div class="actions">
                    <b-button
                        class="btn btn-remove btn-danger-icon-only"
                        v-if="isChiefEditor"
                        variant="inverse-danger"
                        @click="onRemove(row.item.id)"></b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-magazine-editors-component',
    props: ['usersIn', 'magazineId', 'isChiefEditorIn', 'userId'],
    data() {
        return {
            users: this.usersIn,
            editorsTableFields: [
                {
                    key: 'name',
                    label: this.$t('common.first_name'),
                    sortable: true,
                },
                {
                    key: 'surname',
                    label: this.$t('common.last_name'),
                    sortable: true,
                    formatter: (value, key, item) => {
                        return item.preposition !== null ? `${item.preposition} ${value}` : `${value}`;
                    },
                    sortByFormatted: true,
                },
                {
                    key: 'email',
                    label: 'E-mail',
                },
                {
                    key: 'role',
                    label: this.$t('magazine.role'),
                },
                {
                    key: 'userrole',
                    label: 'Type',
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            roleoptions: [
                { value: 1, text: this.$t('magazine.chief_editor') },
                { value: 2, text: this.$t('magazine.editor') },
            ],
            isChiefEditor: !!this.isChiefEditorIn,
        };
    },
    methods: {
        onRemove(id) {
            this.alert
                .confirm(this.$t('magazine.delete_user'), this.$t('magazine.are_you_sure_you_want_to_delete_this_user'))
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();

                    this.axios.delete(this.routes.magazineUserDelete(this.magazineId, id)).then(
                        (response) => {
                            this.users = this.users.filter((user) => user.id !== id);
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },

        updateRole(role, id) {
            this.axios.post(this.routes.magazineUpdateRole(this.magazineId), { user_id: id, role: role }).then(
                (response) => {
                    this.users.forEach(function (user, key) {
                        if (user.id == id) {
                            user.pivot.role = role;
                        }
                    });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateUsers(user) {
            this.users.push(user);
        },
    },
};
</script>

<style scoped lang="scss">
.magazine-editors-management ::v-deep {
    .options {
        .btn-add-existing-user {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            line-height: 1;
            width: 100%;

            i {
                margin-right: map-get($grid-gutter-spacing, 'eight');
            }
        }

        .btn {
            &:not(:last-child) {
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }

    .editors-role-type-select {
        width: auto;
        min-width: 150px;
        border: 1px solid $border-color;
        margin-bottom: 0;
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .magazine-editors-management ::v-deep {
        .apprentice-table-header {
            flex-direction: row;
        }

        .apprentice-table-filters {
            flex: 1 0 auto;
            width: 225px;
            margin-bottom: 0;
        }

        .options {
            .btn-add-existing-user {
                width: auto;
            }
        }

        .options {
            justify-content: flex-end;
            flex: 1 0 auto;
        }
    }
}
</style>
